import { render, staticRenderFns } from "./memberHandbook.vue?vue&type=template&id=35d79a2f&scoped=true&"
import script from "./memberHandbook.vue?vue&type=script&lang=js&"
export * from "./memberHandbook.vue?vue&type=script&lang=js&"
import style0 from "./memberHandbook.vue?vue&type=style&index=0&id=35d79a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d79a2f",
  null
  
)

export default component.exports